import { FC } from "react";
import { TimeRange } from "@vviinn/user-managment-client-ts";

import { useAppDispatch, useAppSelector, changeTimeRange } from "../../store";
import { NamedSelect } from "../../ui/layout/molecules/NamedSelect";

type TimePeriod = {
  id: number;
  name: string;
  value: TimeRange;
};

const timePeriods: TimePeriod[] = [
  { id: 1, name: "Last hour", value: "last_hour" },
  { id: 2, name: "Last day", value: "day" },
  { id: 3, name: "Last month", value: "month" },
  { id: 4, name: "Last year", value: "last_year" },
];

export const TimePeriodSelector: FC = () => {
  const selectedTimeRange = useAppSelector(
    (state) => state.dashboard.selectedTimeRange,
  );
  const dispatch = useAppDispatch();

  return (
    <div className="-mx-4 max-w-fit">
      <NamedSelect
        title="Selected time period"
        options={timePeriods.map(({ name, value }) => ({
          title: name,
          value,
        }))}
        value={selectedTimeRange}
        onChange={({ value }) => dispatch(changeTimeRange(value as TimeRange))}
        styleVariant="newPage"
      />
    </div>
  );
};
